export default "https://storage.googleapis.com/prepweb-prod/dist/3f99a7faa337610045911f25d5b690a0.svg";